//import { Button } from '@mui/material';
import { Box } from '@mui/material';
import React from 'react';
import NavigationTab from '../../../components/actions/NavigationTab';
import Iconify from '../../../components/iconify';
//import Iconify from '../../../components/iconify';
import PageLayout from '../../../layouts/PageLayout';
import UserRoleModal from '../../../modals/Users/UserRoleModal/UserRoleModal';
import { PATH_DASHBOARD } from '../../../routes/paths';
import { onGetFullImagePath } from '../../../utils/general';
import AccountPasswordSection from './sections/AccountPasswordSection';
import DoctorSection from './sections/DoctorSection/DoctorSection';
import GeneralAccountSection from './sections/GeneralAccountSection';
import usePatientAccountPage from './usePatientAccountPage';
import DoctorChatSection from './sections/DoctorChatSection/DoctorChatSection';
import CeludocSection from './sections/CeludocSection/CeludocSection';

const PatientAccountPage = (props) => {
    
    
    const {profile} = props
    const {system, data, actions, form, passwordForm, modalManager} = usePatientAccountPage({profile})

    const {currentTab, file, account, roles, user_roles, isdoctor} = data
    const profileImg =  onGetFullImagePath(account?.image)
    let TABS = [
        {
          value: 'general',
          label: 'General',
          icon: <Iconify icon="ic:round-account-box" />,
          component: (
            <>
                <UserRoleModal 
                open={modalManager.modals.add_role} mode='add' 
                roles={roles} user={account} 
                user_roles={user_roles}
                onClose={() => modalManager.onChangeModalStatus('add_role', false)}
                onRefresh={actions.onRefreshUserRoles}/>
                <GeneralAccountSection 
                    file={file || profileImg} form={form} loading={system.sending} 
                    roles={roles} user_roles={user_roles}
                    onAvatarDrop={actions.onAvatarDrop}
                    onInputChange={actions.onInputChange}
                    onSubmit={actions.onSubmit}
                    onAddRole={() => modalManager.onChangeModalStatus('add_role', true)}
                    onUpdateRole={actions.onUpdateRole}
                />
            </>
          ),
        },
        {
            value: 'doctor_appointments',
            label: 'Funcionalidades',
            icon: <Iconify icon="maki:doctor" />,
            component: <CeludocSection />,
            disabled:true
        },
        {
            value: 'change_password',
            label: 'Seguridad',
            icon: <Iconify icon="ic:round-vpn-key" />,
            component: <AccountPasswordSection profile={profile} onReset={actions.onReset}
              form={passwordForm} loading={system.sending} 
              onInputChange={actions.onPasswordInputChange}
              onSubmit={actions.onUpdatePassword}
            />,
          },
    ];

    return ( 
        <PageLayout stretch={true}
            title='Detalles de cuenta'
            title_seo='Detalles de cuenta | Celu'
            loading={system.loading}
            links={[
                {name:'Dashboard', href:PATH_DASHBOARD.general.app},
                {name:'Usuarios', href:PATH_DASHBOARD.general.doctors},
                {name:'Cuenta', },
            ]}
        >
            <div>

                <NavigationTab options={TABS} value={currentTab} onChange={actions.onChangeSection}/>
                {TABS.map(
                (tab) =>
                    tab.value === currentTab && (
                        <Box key={tab.value} sx={{ mt: 5 }}>
                            {tab.component}
                        </Box>
                    )
                )}
            </div>
        </PageLayout>
     );
}
 
export default PatientAccountPage;